import logo from 'assets/images/foundernest-logo.svg'
import classNames from 'classnames'
import React from 'react'
import { container } from 'theme'

import { createStyles, Fade, Theme, Typography } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

import Card, { CardBody, CardHeader, CardHeaderColor } from './components/Card'
import Footer from './components/Footer'
import { GridContainer, GridItem } from './components/Grid'

class AccountPage extends React.PureComponent<AccountPageProps, AccountPageState> {
  readonly state: AccountPageState = {
    hidden: true,
  }

  componentDidMount() {
    // We add a hidden class to the card and after 700 ms we delete it
    // and the transition appears
    setTimeout(() => {
      this.setState({ hidden: false })
    }, 700)
  }

  render() {
    const { classes, title, children } = this.props
    return (
      <div className={classes.page}>
        <Fade in>
          <img className={classes.logo} src={logo} alt="foundernest" />
        </Fade>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12}>
              <Card
                className={classNames(classes.cardBase, {
                  [classes.cardHidden]: this.state.hidden,
                })}
              >
                <div className={classes.bodyContainer}>
                  <CardHeader color={CardHeaderColor.primary} className={classes.cardHeader}>
                    <Typography variant="subtitle1" color="inherit" className={classes.cardHeaderText}>
                      {title}
                    </Typography>
                  </CardHeader>
                  <CardBody>{children}</CardBody>
                </div>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        <Footer whiteFont />
      </div>
    )
  }
}

type AccountPageState = {
  hidden: boolean
}

type AccountPageProps = {
  title: string
  children: React.ReactNode
} & WithStyles<typeof styles>

const styles = ({ palette, transitions }: Theme) =>
  createStyles({
    page: {
      position: 'relative',
      minHeight: '100vh',
      maxHeight: '1200px',
      height: 'auto',
      // backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${loginBackground})`,
      // backgroundSize: 'cover',
      // backgroundPosition: 'top center',
      backgroundColor: palette.primary.dark,
    },
    logo: {
      position: 'absolute',
      left: '50%',
      top: '5%',
      transform: 'translate(-50%, -50%)',
      width: 200,
      height: 60,
    },
    container: {
      ...container,
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    cardBase: {
      transition: `all .5s ${transitions.easing.sharp}`,
    },
    cardHidden: {
      opacity: 0,
      transform: 'translate3d(0, -60px, 0)',
    },
    bodyContainer: {
      margin: '0',
    },
    cardHeader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 'auto',
      marginLeft: '20px',
      marginRight: '20px',
      marginTop: '-40px',
      padding: '20px 0',
      marginBottom: '15px',
    },
    cardHeaderText: {
      display: 'inline-block',
      marginRight: 4,
    },
    socialIcons: {
      width: 24,
      height: 24,
      maxWidth: '24px',
      marginTop: '0',
      transform: 'none',
      left: '0',
      top: '0',
      lineHeight: '41px',
      fontSize: '20px',
      fill: 'white',
    },
    divider: {
      marginTop: '30px',
      marginBottom: '0px',
      textAlign: 'center',
    },
    cardFooter: {
      paddingTop: '0rem',
      border: '0',
      borderRadius: '6px',
      justifyContent: 'center !important',
    },
    inputIconsColor: {
      fill: '#495057',
    },
  })

export default withStyles(styles)(AccountPage)
